import { useMenu } from 'context/MenuContext';
import styles from './styles.module.scss';
import { getCurrentProduct } from 'utils/productCookies';

function ModuleName() : JSX.Element {
  const { getBreadcrumb } = useMenu();
  const { noun, breadcrumb } = getBreadcrumb();

  return (
    <div id={styles['biobar-module-name']}>
      <p id={styles['biobar-product-name']}>{noun || getCurrentProduct()}</p>
      {breadcrumb &&  <p id={styles['biobar-module-name']}>{breadcrumb || ''}</p> }
    </div>
  );
}

export default ModuleName;